import { render } from "./DefaultDeviceSelector.vue?vue&type=template&id=504ef602&scoped=true"
import script from "./DefaultDeviceSelector.vue?vue&type=script&lang=js"
export * from "./DefaultDeviceSelector.vue?vue&type=script&lang=js"

import "./DefaultDeviceSelector.vue?vue&type=style&index=0&id=504ef602&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504ef602"]])

export default __exports__